import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { Ability } from 'ember-can';
import type CurrentAdminService from 'garaje/services/current-admin';
import { GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST, DELIVERIES_ADMIN, SECURITY, BILLING } from 'garaje/utils/roles';
import _intersection from 'lodash/intersection';

const CAN_VIEW_ROLES = [GLOBAL_ADMIN, LOCATION_ADMIN, RECEPTIONIST, DELIVERIES_ADMIN, SECURITY, BILLING];

export default class TrialEndModalAbility extends Ability {
  @service declare currentAdmin: CurrentAdminService;

  get canView(): boolean {
    const { roleNames } = this.currentAdmin;
    return isPresent(_intersection(CAN_VIEW_ROLES, roleNames));
  }
}
